import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    const {
        rightFeedbackProps,
        leftFeedbackProps,
        answerCount,
    } = state.rootReducer.testPageDetails;

    return {
        rightFeedbackProps,
        answerCount,
        leftFeedbackProps,
    }
}

const McqCorrect = ({
    answerCount,
    rightFeedbackProps: {
        feedbackChoices,
        feedbackImageChoices,
        feedbackQuestionNo,
        feedbackQuestion,
        defaultFeedback,
        correctAnswer,
        score,        
        fileUrl,
    },
    leftFeedbackProps: {
        questionId,
    },
}) => {
    return (
        <span>
          <h4 className="ans-correct">Your answer is correct</h4>
              <div className="record-container">
                 <div className="audio-player audio-player-correct">
                    <audio src={fileUrl} controls controlsList="nodownload"></audio>
                    <small>Your answer</small>
                 </div>
              </div>
          </span>
    )
}

export default connect(mapStateToProps)(McqCorrect);